import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { LinkService } from '../../../_services/langhfre.service';
//declare function ire(string,{}): any;
@Component({
  selector: 'app-consistency-checks',
  templateUrl: './consistency-checks.component.html',
  styleUrls: ['./consistency-checks.component.scss']
})
export class ConsistencyChecksComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService
  ) { }

  ngOnInit() {
    this.titleService.setTitle("用語統一機能で英文の精度を高める | Trinka");
    this.metaTagService.updateTag({ name: 'description', content: "Trinka（トリンカ）の用語統一チェック機能を使えばワンクリックで原稿全体の表記を一括で統一。精度の高い英文を短時間で作成できます。" });
    this.metaTagService.updateTag({ property: 'og:title', content: "用語統一機能で英文の精度を高める | Trinka" });
    this.metaTagService.updateTag({ property: 'og:description', content: "Trinka（トリンカ）の用語統一チェック機能を使えばワンクリックで原稿全体の表記を一括で統一。精度の高い英文を短時間で作成できます。" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/jp/features/consistency-check' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/features/s2.svg' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: '用語統一機能で英文の精度を高める | Trinka' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Trinka（トリンカ）の用語統一チェック機能を使えばワンクリックで原稿全体の表記を一括で統一。精度の高い英文を短時間で作成できます。" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://trinka.ai/assets/images/features/s2.svg' });
    this.metaTagService.updateTag({ name: 'language', content: 'ja-jp' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/jp/features/consistency-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/features/consistency-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/features/consistency-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/features/consistency-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/features/consistency-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/features/consistency-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/features/consistency-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/features/consistency-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/features/consistency-check' });
    if (isPlatformBrowser(this.platformId)) {
      // $.getScript('../../../assets/js/particles.min.js', function(){});
      $.getScript('../../../assets/js/wisepop.js', function () { });
    }
    //ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()});
  }
  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      $.getScript('../../../../assets/js/home_client_slider.js', function () { });
      $('#closedPopup, #wordPluginPopup').click(function () {
        $('iframe.youtubeVideoForTryDemo').remove()
      });

      $('#VewiVideoSection').click(function () {
        if (!$('#iframe').length) {
          $('#iframeHolder').html('<iframe class="youtubeVideoForTryDemo" id="iframe" src="https://www.youtube.com/embed/hTaMLLHICCo" width="100%" height="450"></iframe>');
        }
      });

    }
  }

  

}
